exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slideshow {\n  width: 100%;\n}\n.slideshow .VueCarousel-wrapper {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n.slideshow .VueCarousel-inner {\n  max-height: 100%;\n  min-height: 0;\n  flex-grow: 1;\n}\n.slideshow .VueCarousel-slide {\n  display: flex;\n  align-items: center;\n}\n.slideshow .VueCarousel-slide .slide-image {\n  max-height: 100%;\n  width: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n  display: block;\n  margin: 0 auto;\n}", ""]);

// exports
